"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingCalendarModal = void 0;
var _modal = require("@cian/ui-kit/modal");
var styles = _interopRequireWildcard(require("./styles.css"));
var _Day = require("./Day");
var _hooks = require("./hooks");
var _DateRangeWrapper = require("../DateRangeWrapper");
var _DesktopModal = require("../DesktopModal");
var _Error = require("../Error");
var _Loading = require("../Loading");
var _ModalContentDesktop = require("../ModalContentDesktop");
var _ModalContentMobile = require("../ModalContentMobile");
var _ModalFooterDesktop = require("../ModalFooterDesktop");
var _ModalFooterMobile = require("../ModalFooterMobile");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BookingCalendarModal = props => {
  const {
    from,
    to,
    isMobile,
    isInitialLoading,
    isSelectedDatesInfoLoading,
    showGlobalError,
    isSubmitButtonDisabled,
    isResetButtonDisabled,
    footerText,
    submitButtonText,
    minDate,
    maxDate,
    checkDayDisabled,
    onChange,
    onApply,
    onReset,
    onClose,
    ranges,
    hasSelectedRange,
    error,
    getShowTooltip,
    processedDaysAvailability
  } = (0, _hooks.useBookingCalendar)(props);
  const DesktopModalComponent = props.isRedesign ? _DesktopModal.DesktopModal : _modal.ModalWindow;
  const ModalComponent = isMobile ? _modal.ModalFullscreen : DesktopModalComponent;
  const ContentComponent = isMobile ? _ModalContentMobile.ModalContentMobile : _ModalContentDesktop.ModalContentDesktop;
  const FooterComponent = isMobile ? _ModalFooterMobile.ModalFooterMobile : _ModalFooterDesktop.ModalFooterDesktop;
  if (showGlobalError) {
    return /*#__PURE__*/React.createElement(_Error.Error, null);
  }
  return /*#__PURE__*/React.createElement(ModalComponent, {
    onClose: onClose,
    open: true,
    portal: false,
    theme: "white",
    size: "M",
    header: false,
    fixed: false
  }, /*#__PURE__*/React.createElement(ContentComponent, {
    showHeader: !props.isRedesign,
    showResetButton: props.showResetButton,
    footer: /*#__PURE__*/React.createElement(FooterComponent, {
      isRedesign: !!props.isRedesign,
      loading: isSelectedDatesInfoLoading,
      isResetButtonDisabled: isResetButtonDisabled,
      isSubmitButtonDisabled: isSubmitButtonDisabled,
      showResetButton: props.showResetButton,
      title: footerText,
      submitButtonText: submitButtonText,
      onApply: onApply,
      onReset: onReset
    }),
    onClose: onClose,
    onReset: onReset
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['date-range-wrapper']
  }, (!isMobile && isSelectedDatesInfoLoading || isInitialLoading) && /*#__PURE__*/React.createElement(_Loading.Loading, {
    isRedesign: props.isRedesign,
    transparent: isSelectedDatesInfoLoading
  }), /*#__PURE__*/React.createElement(_DateRangeWrapper.DateRangeWrapper, {
    isRedesign: props.isRedesign,
    minDate: minDate,
    maxDate: maxDate,
    disabledDay: checkDayDisabled,
    dayContentRenderer: date => /*#__PURE__*/React.createElement(_Day.Day, {
      from: from,
      to: to,
      date: date,
      availabilityArray: processedDaysAvailability,
      getShowTooltip: getShowTooltip,
      tooltipText: error
    }),
    onChange: onChange,
    ranges: ranges,
    hasSelectedRange: hasSelectedRange
  }))));
};
exports.BookingCalendarModal = BookingCalendarModal;